import { Map as ImmutableMap } from 'immutable';

import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';
import store from 'app-components/utils/redux-store';

import type { ManageUpdatesDialogProps } from './index';

export const MANAGE_UPDATES_DIALOG = 'MANAGE_UPDATES_DIALOG';

export const showManageUpdatesDialog = (props: ManageUpdatesDialogProps) => {
  store?.dispatch(
    rootUiActions.createDialog(
      rootUiTypes.mkRootUiData({
        type: MANAGE_UPDATES_DIALOG,
        props: ImmutableMap(props),
      }),
    ),
  );
};

export default showManageUpdatesDialog;
